"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sample_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/Sample"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const map_1 = __importDefault(require("lodash/map"));
const SampleCoreMetadata_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/SampleCoreMetadata"));
const Report_1 = __importStar(require("@becrop/components/Toolkit/Heatmap2/models/report/Report"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const ReportDisease_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportDisease"));
const ReportPGP_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportPGP"));
const ReportNutrientFunction_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/models/report/ReportNutrientFunction"));
/**
 * Filter null values in an array
 * @param arr
 */
function filterNulls(arr) {
    return arr.filter(x => x !== null);
}
/**
 * Return the min of an array of dates or null
 * @param arr
 */
function minOrNull(arr) {
    const values = filterNulls(arr);
    if (!values.length)
        return null;
    if (values[0] instanceof Date) {
        const times = values.map(d => d.getTime());
        return new Date(Math.min(...times));
    }
    if ((0, isNumber_1.default)(values[0])) {
        const numbers = values;
        return Math.min(...numbers);
    }
    throw "Not supported type at minOrNull";
}
/**
 * Returns the value if all elements have the same
 * Otherwise null
 * @param arr
 */
function valueIfAllEqual(arr) {
    const values = filterNulls(arr);
    if (!values.length)
        return null;
    const first = values[0];
    if (values.some(v => v !== first))
        return null;
    return first;
}
function numberAVG(arr) {
    const values = filterNulls(arr);
    if (!values.length)
        return null;
    return values.reduce((a, b) => a + b) / values.length;
}
/**
 * https://stackoverflow.com/questions/45309447/calculating-median-javascript
 * @param values
 */
function median(values) {
    if (values.length === 0)
        return 0;
    values.sort(function (a, b) {
        return a - b;
    });
    const half = Math.floor(values.length / 2);
    if (values.length % 2)
        return values[half];
    return (values[half - 1] + values[half]) / 2.0;
}
const avgRankMerger = (ranks) => {
    return numberAVG(ranks);
};
const medRankMerger = (ranks) => {
    const values = filterNulls(ranks);
    if (!values.length)
        return null;
    return median(values);
};
const minRankMerger = (ranks) => {
    const values = filterNulls(ranks);
    if (!values.length)
        return null;
    return Math.min(...values);
};
const maxRankMerger = (ranks) => {
    const values = filterNulls(ranks);
    if (!values.length)
        return null;
    return Math.max(...values);
};
const MERGERS = {
    avg: avgRankMerger,
    med: medRankMerger,
    min: minRankMerger,
    max: maxRankMerger,
};
/**
 * A group of samples with a name
 */
class Group {
    constructor(name, samples) {
        this.name = name;
        this.samples = samples;
    }
}
/**
 * Main alchemy class with static methods to crete the samples
 */
class Alchemy {
    static create(samples, option, groupBy) {
        let groups;
        // TODO: Support more cases
        // Create the groups of samples
        if (groupBy.origin === 'core') {
            if (groupBy.id === 'parcel') {
                groups = this.groupByParcel(samples);
            }
            else {
                throw "Alchemy group not supported";
            }
        }
        else if (groupBy.origin === 'csv') {
            groups = this.groupByCSVField(samples, groupBy.field);
        }
        else {
            throw "Alchemy group not supported";
        }
        // Create the representative per group
        return groups.map(group => this.mergeSamples(group, option));
    }
    static groupByParcel(samples) {
        const dict = (0, groupBy_1.default)(samples, sample => {
            return sample.coreMetadata.parcel_name;
        });
        return (0, map_1.default)(dict, arr => {
            const name = arr[0].coreMetadata.parcel_name || '';
            return new Group(name, arr);
        });
    }
    static groupByCSVField(samples, field) {
        const dict = (0, groupBy_1.default)(samples, sample => {
            return sample.csvMetadata.values[field.id];
        });
        return (0, map_1.default)(dict, arr => {
            const name = (arr[0].csvMetadata.values[field.id] + '') || '';
            return new Group(name, arr);
        });
    }
    static mergeSamples(group, option) {
        const merger = MERGERS[option];
        const samples = group.samples;
        //
        // Create the alchemy sample
        //
        const alchemy = new Sample_1.default();
        alchemy.alchemy = true;
        alchemy.alchemy_samples = group.samples;
        alchemy.code = group.samples[0].code;
        if (group.samples.length > 1) {
            alchemy.code += `+${group.samples.length - 1}`;
        }
        alchemy.name = group.name + ` (${option})`;
        //
        // Core Metadata
        //
        const cores = samples.map(s => s.coreMetadata);
        alchemy.coreMetadata = this.mergeCoreMetadata(cores);
        //
        // CSV Metadata
        //
        // TODO
        //
        // Report
        //
        const reports = samples.map(s => s.report);
        alchemy.report = this.mergeReports(reports, merger);
        return alchemy;
    }
    static mergeCoreMetadata(cores) {
        const core = new SampleCoreMetadata_1.default();
        core.date = minOrNull(cores.map(c => c.date));
        core.plant_year = minOrNull(cores.map(c => c.plant_year));
        core.soil_type_id = valueIfAllEqual(cores.map(c => c.soil_type_id));
        core.org_practises = valueIfAllEqual(cores.map(c => c.org_practises));
        core.art_irrigation = valueIfAllEqual(cores.map(c => c.art_irrigation));
        core.bio_methods = valueIfAllEqual(cores.map(c => c.bio_methods));
        core.density = numberAVG(cores.map(c => c.density));
        core.variety = valueIfAllEqual(cores.map(c => c.variety));
        core.parcel_name = valueIfAllEqual(cores.map(c => c.parcel_name));
        return core;
    }
    static mergeReports(reports, merger) {
        const report = new Report_1.default();
        //
        // Ranks
        //
        const rranks = reports.map(r => r.ranks);
        report.ranks = this.mergeReportRanks(rranks, merger);
        //
        // Diseases
        //
        const d_groups = reports.map(r => r.diseases);
        report.diseases = this.mergeReportDiseases(d_groups, merger);
        //
        // Grow promoters
        //
        const gp_groups = reports.map(r => r.grow_promoters);
        report.grow_promoters = this.mergeReportGrowPromoters(gp_groups, merger);
        //
        // Nutrient functions
        //
        const nf_groups = reports.map(r => r.nutrient_functions);
        report.nutrient_functions = this.mergeReportNutrientFunctions(nf_groups, merger);
        return report;
    }
    static mergeReportRanks(rranks, merger) {
        const ranks = new Report_1.ReportRanks();
        for (const k of Object.keys(ranks)) {
            const key = k;
            const vals = rranks.map(r => r[key]);
            let val = merger(vals);
            val = Math.round(val);
            ranks[key] = val;
        }
        return ranks;
    }
    static mergeReportDiseases(groups, merger) {
        return groups[0].map(first => {
            // Get the diseases in other groups
            const rDiseases = groups.map(group => {
                return group.find(d => d.disease === first.disease);
            }).filter(d => d && d.detected);
            const alchemy = new ReportDisease_1.default();
            alchemy.is_major = first.is_major;
            alchemy.disease = first.disease;
            if (rDiseases.length) {
                alchemy.detected = true;
                const vals = rDiseases.map(d => d.rank);
                const val = merger(vals);
                alchemy.rank = Math.round(val);
            }
            return alchemy;
        });
    }
    static mergeReportGrowPromoters(groups, merger) {
        return groups[0].map(first => {
            // Get the promoters in other groups
            const rPGP = groups.map(group => {
                return group.find(d => d.pgp === first.pgp);
            }).filter(d => d && d.rank && d.rank > 0);
            const alchemy = new ReportPGP_1.default();
            alchemy.pgp = first.pgp;
            if (rPGP.length) {
                alchemy.detected = true;
                const vals = rPGP.map(d => d.rank);
                const val = merger(vals);
                alchemy.rank = Math.round(val);
            }
            return alchemy;
        });
    }
    static mergeReportNutrientFunctions(groups, merger) {
        return groups[0].map(first => {
            // Get the diseases in other groups
            const rNutrient = groups.map(group => {
                return group.find(d => d.nutrientFunction === first.nutrientFunction);
            }).filter(d => d && d.rank && d.rank > 0);
            const alchemy = new ReportNutrientFunction_1.default();
            alchemy.nutrientFunction = first.nutrientFunction;
            if (rNutrient.length) {
                const vals = rNutrient.map(d => d.rank);
                const val = merger(vals);
                alchemy.rank = Math.round(val);
            }
            return alchemy;
        });
    }
}
exports.default = Alchemy;
